export default __webpack_public_path__ + "static/media/Clinic_Dir_Bio_Jackie_Schultz_Lakewood_05292025.924c33e5.pdf";